document.addEventListener('DOMContentLoaded', () => {
  function setupRequiredNote(context = document) {
    const note = context.querySelector('[name="note"]');
    if (!note) return;

    const checkoutButtons = context.querySelectorAll(
      'a[href^="/checkout"], button[name="checkout"], input[name="checkout"]'
    );
    if (checkoutButtons.length === 0) return;

    let error = note.parentElement.querySelector('.pickup-note-error');
    if (!error) {
      error = document.createElement('div');
      error.className = 'pickup-note-error';
      error.style.marginTop = '10px';
      error.style.fontWeight = '600';
      error.style.color = '#c0392b';
      error.style.display = 'none';
      error.textContent = 'Bitte trage ein Abholdatum ein.';
      note.parentElement.style.display = 'flex';
note.parentElement.style.flexDirection = 'column';
note.parentElement.appendChild(error);
    }

    const validate = () => {
      const ok = note.value.trim().length > 0;
      error.style.display = ok ? 'none' : 'block';
      note.setAttribute('aria-invalid', ok ? 'false' : 'true');
      return ok;
    };

    checkoutButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (!validate()) {
          e.preventDefault();
          e.stopPropagation();
          note.focus();
        }
      }, true);
    });

    note.addEventListener('input', validate);
  }

  setupRequiredNote(document);

  // Für Dawn Drawer (wird dynamisch geladen)
  const observer = new MutationObserver(() => setupRequiredNote(document));
  observer.observe(document.body, { childList: true, subtree: true });
});